// extracted by mini-css-extract-plugin
export default {"parties":"parties_block-module__parties--lTAR3","text":"parties_block-module__text--6aPYv"};